if (!customElements.get("f-cart-goal")) {
  class FCartGoal extends HTMLElement {
    constructor() {
      super();
      this.goal = Number(this.dataset.cartGoal) * (Number(window.Shopify.currency.rate) || 1) || 0;
      this.moneyFormat = window.FoxThemeSettings.money_format;
      this.enableConfetti = this.dataset.enableConfetti === "true";
    }
    connectedCallback() {
      this.updateCartGoal(Number(this.dataset.cartTotal));
      window.FoxThemeEvents.subscribe("ON_CART_UPDATED", ({ items_subtotal_price }) => this.updateCartGoal(items_subtotal_price));
      window.FoxThemeEvents.subscribe("ON_ITEM_ADDED", async () => {
        const newCart = await window.FoxThemeCartHelpers.getState();
        newCart && this.updateCartGoal(newCart.items_subtotal_price);
      });
      this.confettiShow = this.goalDone;
    }
    updateCartGoal(cartTotal) {
      const cartTotalFormatted = cartTotal / 100;
      this.goalLeft = this.goal - cartTotalFormatted;
      this.goalDone = this.goalLeft <= 0;
      this.style.setProperty("--progress", `${Math.min((cartTotalFormatted * 100) / this.goal, 100)}%`);
      this.dataset.total = cartTotalFormatted;
      this.goalDone ? this.completeGoal() : this.incompleteGoal(cartTotalFormatted);
    }
    completeGoal() {
      this.classList.add("f-cartgoal--done", "shakeY");
      this.enableConfetti && this.showConfetti();
    }
    incompleteGoal(cartTotalFormatted) {
      this.querySelector("[data-left-to-spend]").innerHTML = formatMoney(this.goalLeft * 100, this.moneyFormat);
      this.classList.remove("f-cartgoal--done", "shakeY");
    }
    showConfetti() {
      const cartDrawer = this.closest(".f-cart-drawer__inner");
      if (!this.confettiShow && cartDrawer) {
        setTimeout(() => {
          new window.FoxTheme.Confetti(cartDrawer);
          this.confettiShow = true;
        }, 800);
      }
    }
  }
  customElements.define("f-cart-goal", FCartGoal);
}
